export const STEPS_USING_VEHICLE_LOADER = ['zip_code'];
